import React from "react";
import {
  AttributeName,
  AttributeValue,
  NameValuePairContainer,
} from "./nameValuePair.styles";

interface INameValuePair {
  name: string;
  value: string | null | undefined;
}

const NameValuePair = ({ name, value }: INameValuePair) => {
  return (
    <NameValuePairContainer>
      <AttributeName>{name}</AttributeName>
      <AttributeValue>{value || "-"}</AttributeValue>
    </NameValuePairContainer>
  );
};

export default NameValuePair;
